module.exports = __webpack_public_path__ + "img/chargers-map.a5c09c2e.png";